import qs from 'qs';

import { client } from '@api/client';
import { URL } from '@api/urls';

import { IItemsResponse } from '@interfaces/common/response';
import {
	ICellsForSectorsDto,
	ICreateSectorsSettingsDTO,
	IGetSectorsByFilterDTO,
	ISectorSettingDTO,
	TGetAllSectorsDTO,
} from '@interfaces/map/dto/sectorsDTO';

const { sectorsFiltered, sectors, allCellsForSectors } = URL;

export const getSectorsByFilter = ({
	page,
	pageSize,
	sortDirection,
	sortFieldName,
	technology,
	vendor,
}: Omit<IGetSectorsByFilterDTO, 'organizationId'>): Promise<IItemsResponse<ISectorSettingDTO>> => {
	return client.get(sectorsFiltered, {
		params: {
			page,
			pageSize,
			sortDirection,
			sortFieldName,
			technology,
			vendor,
		},
	});
};

export const createSectorsSettings = (dto: ICreateSectorsSettingsDTO): Promise<void> => {
	return client.post(`/${sectors}`, dto);
};

export const updateSectorsSettings = (id: string, dto: ICreateSectorsSettingsDTO): Promise<void> => {
	return client.put(`${sectors}/${id}`, dto);
};

export const getAllSectors = (): Promise<TGetAllSectorsDTO> => {
	return client.get(sectors);
};

export const removeSectorsSettings = (id: string): Promise<void> => {
	return client.post(`${sectors}/${id}/delete`, {});
};
export const getAllCellsForSectors = (siteIds: string[]): Promise<ICellsForSectorsDto> => {
	return client.get(allCellsForSectors, {
		params: { ids: siteIds },
		paramsSerializer: params => qs.stringify(params, { indices: false }),
	});
};
